let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { Routes } from './Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GlobalStyle = createGlobalStyle(_t || (_t = _`
  body, html {
    min-height: 100%;
  }


  .page {
    color: $#33475C;
  }

  .is--text--help {
    color: #f8f9fa !important;
    font-weight: 300;
    padding-top: 4px;
    padding-bottom: 4px;
  }
`));
export default function AppLayout() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(Routes, {})]
  });
}